import axios, {AxiosInstance, AxiosPromise} from 'axios';

const baseApiUrl = '/api/rums/revenue';

export default class RevenueService {
    private axios: AxiosInstance;

    constructor() {
        this.axios = axios;
    }

    public getRevenueReport():Promise<any> {
        return new Promise<any>((resolve,reject) => {

            axios.get(baseApiUrl).then(function(res) {
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        });
    }
}
